module.exports = __webpack_public_path__ + "img/pdf.fb5b0c6c.svg";